import Link from 'next/link'
import { tv, type VariantProps } from 'tailwind-variants'

export const styles = tv(
	{
		slots: {
			item: 'text-sm last-of-type:opacity-75 font-bold capitalize',
			itemList: 'flex text-gray-700 flex-wrap',
			separator: 'px-2',
		},
		variants: {
			size: {
				lg: {
					item: 'text-base',
				},
			},
		},
	},
	{ responsiveVariants: ['lg'] },
)

const { item, itemList, separator } = styles({
	size: {
		lg: 'lg',
	},
})

interface BreadcrumbsProps extends VariantProps<typeof styles> {
	className?: string
	items: Array<{ label: string; href: string }>
}

export const Breadcrumbs = ({ className, items, ...rest }: BreadcrumbsProps) => (
	<ul className={itemList({ class: className })}>
		{items.map((breadcrumb, index) => (
			<li className={item()} key={index}>
				{breadcrumb.href ? <Link href={breadcrumb.href}>{breadcrumb.label}</Link> : <span>{breadcrumb.label}</span>}
				{index < items.length - 1 && <span className={separator()}>/</span>}
			</li>
		))}
	</ul>
)
